module.exports = __webpack_public_path__ + "img/image3.568df91b.jpg";